import { getConfig } from '../configure';
export default getConfig;
